// extracted by mini-css-extract-plugin
module.exports =  {"details":"gVEO7K4WJdv_umIeqiPg","expiry":"v_Id5mDg0DqUZIMX5HM6","icon":"H0ZjQwbpTPezqQ8K9dnt"};